import React from 'react';
import BookDemoButtonComponent from '../../BookDemoButton';
import { Tenant } from '@framework/tenant/vo/types/Tenant';
import useScheduleDemoModal from '../useScheduleDemoModal';
import { ILogoProps } from '@dealroadshow/uikit-logo/types';
import { IScheduleDemoFormValues } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm/interfaces';

export interface IProps {
  tenant: Tenant,
  logoComponent?: React.ComponentType<ILogoProps>,
  buttonComponent?: React.ElementType,
  title?: string,
  className?: string,
  defaultPhoneCountry?: string,
  getInitialFormValues?: () => IScheduleDemoFormValues | null,
}

const BookDemoButton = ({
  tenant,
  logoComponent,
  buttonComponent,
  getInitialFormValues,
  title,
  className,
  defaultPhoneCountry,
}: IProps) => {
  const {
    isScheduleDemoModalVisible,
    toggleScheduleDemoModal,
    ScheduleDemoModal,
  } = useScheduleDemoModal();

  return (
    <BookDemoButtonComponent
      isScheduleDemoModalVisible={ isScheduleDemoModalVisible }
      toggleScheduleDemoModal={ toggleScheduleDemoModal }
      logoComponent={ logoComponent! }
      scheduleDemoModal={ ScheduleDemoModal }
      tenant={ tenant }
      buttonComponent={ buttonComponent }
      title={ title }
      className={ className }
      defaultPhoneCountry={ defaultPhoneCountry }
      getInitialFormValues={ getInitialFormValues }
    />
  );
};

export default BookDemoButton;
